export const RECAPTCHA_SITE_KEY = "6LdBaNIsAAAAAJICKO8Ebd5sm9LU9MdjY4XPyIZc";
